<template>
  <div class="city-list">
    <list-page-header-no-line :page-info="pageInfo">

       <div class="hero-search__left">
         <div class="hero-search__select fw">
           <div class="hero-search__title"></div>
            <v-select v-model="search" :options="dorms" placeholder="Search by movie name..." @onselect="selectMovie"/>
            </div>
            </div>
      <v-button
        class="hero-search__submit green"
        icon="icon-search"
        icon-position="left"
        title="Search Movie"
        @click.native="selectMovie"
      />
    </list-page-header-no-line>
    <FeaturedDormsNoTabs />

  </div>
</template>

<script>
import Utiliy from '../common'
import ListPageHeaderNoLine from '@/components/ListPageHeaderNoLine'
import FeaturedDormsNoTabs from '@/components/Home/FeaturedDormsNoTabs.vue'
import axios from 'axios'
export default {
  name: 'DormSearch',
  components: {
    ListPageHeaderNoLine, FeaturedDormsNoTabs
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Search Movie',
       meta: [
         { name: 'description', content: this.pageInfo.text },
         { name: 'keywords', content: 'search movie, find movie, yurt bulma, holywood skyline, all movies, family movies, action movies' }
       ],
       link: [
         { rel: 'canonical', href: this.url }
       ]      
    }
  },  
  data () {
    return {
      search: '',
      url: '',
      pageInfo: {
        icon: require('@/assets/img/yurt-ara.svg'),
        title: '<span class="color-light-green">Search movies</span> by name!',
        text: 'Find your dream movie instantly! We gather most popular movies in town for you!'
      },
      dorms: [],
      cityID: null,
      featuredCities: [],
      cities: [],
      searchUrl: {},
      errors: []
    }
  },
  methods: {
    onSelect (opt) {
      // console.log(opt)
    },
    selectMovie (opt) {
      // let selected = this.$refs.myinput.value
      let selectedMovie  = this.dorms.find(function (movie) { return movie.original_title === opt.original_title } )
      if(selectedMovie) {

        const slug = Utiliy.string_to_slug(selectedMovie.original_title)
        this.$router.push({ name: 'MovieDetail', params: { slug: slug, id: opt.id } })
        
        window.localStorage.setItem('dormid', opt.id)
         let url = window.location.origin + '/movie-search'
        //let url = 'https://İptal Ve İade Koşulları.com/' + slug + '-y-' + opt.id
        window.localStorage.setItem('url', url)
      } 

    },
    getPopularMovies () {
      let self = this
      //axios.get('/site/home/cities?take=7')
      axios.get(`/3/movie/popular?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&page=1`)
        .then(response => {
          self.featuredCities = response.data.results
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getMoviesList () {
      let self = this
      //axios.get('/site/search/dorms')
      //axios.get(`/3/discover/movie?api_key=a11ac97c6bdb99adc0845654be0902a8&include_adult=true&with_companies=${this.$route.params.id}&page=${this.page}`)
      axios.get(`/3/search/movie?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&query=page=a&page=1&include_adult=false`)
        .then(response => {
           self.dorms = response.data.results
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getMoviesList2 (ss) {
      let self = this
      //axios.get('/site/search/dorms')
      //axios.get(`/3/discover/movie?api_key=a11ac97c6bdb99adc0845654be0902a8&include_adult=true&with_companies=${this.$route.params.id}&page=${this.page}`)
      axios.get(`/3/search/movie?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&query=${ss}&page=1&include_adult=false`)
        .then(response => {
           self.dorms = response.data.results
        })
        .catch(e => {
          this.errors.push(e)
        })
    }    
  },
  created () {
    this.getPopularMovies()
    this.getMoviesList()
    this.url = window.location.origin + '/movie-search'
  },
  mounted () {
    var self = this
/*     this.$refs.myinput.addEventListener('input', function (evt) {
    self.selectDorm()
  }) */
  },


 watch: { 'search' () { 
   this.getMoviesList2(this.search)
//   this.updateList() 
    // temporary solution  
   } }, 

}
</script>

<style lang="scss" scoped>
@import "../assets/scss/components/city-list";
</style>
